import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Connect wallet',
    description: 'Select where you want to receive LBTC',
    tosText:
      'I certify that I have read and accept the <a href={link} target="_blank" rel="norefferer">Terms of Service</a>',
  },
};
